/* eslint-disable @typescript-eslint/no-unused-vars */
import { NgModule } from '@angular/core';

import { PermissionCheckerService } from './auth/permission-checker.service';
import { TokenService } from './auth/token.service';
import { EafUserConfigurationService } from './eaf-user-configuration.service';
import { EafHttpConfiguration } from './eafHttpInterceptor';
import { FeatureCheckerService } from './features/feature-checker.service';
import { LocalizationService } from './localization/localization.service';
import { LogService } from './log/log.service';
import { MessageService } from './message/message.service';
import { EafMultiTenancyService } from './multi-tenancy/eaf-multi-tenancy.service';
import { NotifyService } from './notify/notify.service';
import { EafSessionService } from './session/eaf-session.service';
import { SettingService } from './settings/setting.service';
import { StorageService } from './utils/storage.service';

@NgModule({
  declarations: [],

  providers: [
    EafSessionService,
    PermissionCheckerService,
    FeatureCheckerService,
    LocalizationService,
    SettingService,
    NotifyService,
    MessageService,
    LogService,
    EafMultiTenancyService,
    EafUserConfigurationService,
    EafHttpConfiguration,
    TokenService,
    StorageService,
  ],
})
export class EafModule {}
